import styled from 'styled-components';

export const ProgressTrack = styled.div`
  width: 100%;
  height: 6px;
  border-radius: 100px;
  background: ${({ theme }) => theme.mediumGray};
  overflow: hidden;
`;

/** Never fully empty: a queued report is already at 5% and should look alive. */
export const ProgressFill = styled.div<{ $percent: number }>`
  height: 100%;
  width: ${({ $percent }) => Math.min(100, Math.max(4, $percent))}%;
  border-radius: inherit;
  background: ${({ theme }) => theme.primary};
  transition: width 0.6s ease;
`;
